import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BootstrapWorldRecordsComponent } from './components/bootstrap-world-records/bootstrap-world-records.component';

const routes: Routes = [
  {
    path: '',
    component: BootstrapWorldRecordsComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WorldRecordsRoutingModule {}
